export interface RootDashBoardData {
  tasks: Task[];
  orders: Order[];
}
export interface Order {
  role: string;
  //userName: string;
  status: string;
  countStatus: number;
}
export interface Task {
  role: string;
  status: string;
  countStatus: number;
}


export const DashBoardData :RootDashBoardData= {
  "tasks": [
    {
      "role": "Assembly",
      "status": "New",
      "countStatus": 0
    },
    {
      "role": "Inventory count",
      "status": "New",
      "countStatus": 0
    },
    {
      "role": "Good received",
      "status": "New",
      "countStatus": 0
    },
    {
      "role": "Warehouse changes",
      "status": "New",
      "countStatus": 0
    },
    {
      "role": "Assembly",
      "status": "In Progress",
      "countStatus": 0
    },
    {
      "role": "Inventory count",
      "status": "In Progress",
      "countStatus": 0
    },
    {
      "role": "Good received",
      "status": "In Progress",
      "countStatus": 0
    },
    {
      "role": "Warehouse changes",
      "status": "In Progress",
      "countStatus": 0
    },
    {
      "role": "Assembly",
      "status": "Complete",
      "countStatus": 0
    },
    {
      "role": "Inventory count",
      "status": "Complete",
      "countStatus": 0
    },
    {
      "role": "Good received",
      "status": "Complete",
      "countStatus": 0
    },
    {
      "role": "Warehouse changes",
      "status": "Complete",
      "countStatus": 0
    },
    {
      "role": "Assembly",
      "status": "Pending",
      "countStatus": 0
    },
    {
      "role": "Inventory count",
      "status": "Pending",
      "countStatus": 0
    },
    {
      "role": "Good received",
      "status": "Pending",
      "countStatus": 0
    },
    {
      "role": "Warehouse changes",
      "status": "Pending",
      "countStatus": 0
    }
  ],
  "orders": [
    {
      "role": "Picker",
      "status": "New",
      "countStatus": 0
    },
    {
      "role": "Packer",
      "status": "New",
      "countStatus": 0
    },
    {
      "role": "Shipper",
      "status": "New",
      "countStatus": 0
    },
    {
      "role": "QC",
      "status": "New",
      "countStatus": 0
    },
    {
      "role": "Picker",
      "status": "In Progress",
      "countStatus": 0
    },
    {
      "role": "Packer",
      "status": "In Progress",
      "countStatus": 0
    },
    {
      "role": "Shipper",
      "status": "In Progress",
      "countStatus": 0
    },
    {
      "role": "QC",
      "status": "In Progress",
      "countStatus": 0
    },
    {
      "role": "Picker",
      "status": "Complete",
      "countStatus": 0
    },
    {
      "role": "Packer",
      "status": "Complete",
      "countStatus": 0
    },
    {
      "role": "Shipper",
      "status": "Complete",
      "countStatus": 0
    },
    {
      "role": "QC",
      "status": "Complete",
      "countStatus": 0
    },
    {
      "role": "Picker",
      "status": "Pending",
      "countStatus": 0
    },
    {
      "role": "Packer",
      "status": "Pending",
      "countStatus": 0
    },
    
    {
      "role": "Shipper",
      "status": "Pending",
      "countStatus": 0
    },
    {
      "role": "QC",
      "status": "Pending",
      "countStatus": 0
    }
  ]
}